import React, { useState, useCallback, useEffect , useRef} from "react";
import { connect } from "react-redux";
import axios from "axios";
import { GetFormatedDateWithTime } from '../../../../common/Utils';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import Form from './Form';
import MessageDetailList from './MessageDetailList';
import { confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    StateStoring,
    Lookup
} from "devextreme-react/data-grid";
import { Button, SelectBox, TextArea } from 'devextreme-react';
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../../common/GridLayout";
import SidePanelGrid from '../../../../common/SidePanelGrid';

const List = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    var url = "rf/Message/GetMessageHeader";
    const [dataSource, setDataSource] = useState(null);

    const [headerId, setHeaderId] = useState(null);
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);
    const panelHeight = searchPanelStatus ? 'calc(100vh - 315px)' : 'calc(100vh - 144px)';
    const [pageTitle, setPageTitle] = useState('RF Offline Messages');
    const panelContentHeight = searchPanelStatus ? 'calc(100vh - 395px)' : 'calc(100vh - 224px)';
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [currentLayout, setCurrentLayout] = useState("Default");
    const gridKey = "27C1BCA1-5ED7-4297-9F2E-78117B16C8A9";
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const initialFormFields = {
        STATUS: '',
        StatusInfo: '',
        ProcessName: '',
        ProcessPage: '',
        RecordNumber: '',
        CreationDateTime: '',
        TransmissionDate: '',
        User: '',
        Value: '',
        FieldName: '',
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const onContentReady = async (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", dataSource);
        }
    }
    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
        setHeaderId(data.selectedRowKeys[0]);
    }
    const onRowInserted = (e) => {
        e.data['RConsignee'] = props.headerId;
    };
    const statusOptions = [
        { ID: 'F', Text: "Failed Message" },
        { ID: 'Z', Text: "Closed and Processed" },
        { ID: 'O', Text: "Open and Unprocessed" },
    ];
    const GetGridData = (accessToken, formFields) => {
        var url = "rf/Message/GetMessageHeader";
        const resultData = createStore({
            key: 'RowId',
            loadParams:
            {
                STATUS: function () {
                    return formFields.STATUS;
                },
                StatusInfo: function () {
                    return formFields.StatusInfo;
                },
                ProcessName: function () {
                    return formFields.ProcessName;
                },
                ProcessPage: function () {
                    return formFields.ProcessPage;
                },
                RecordNumber: function () {
                    return formFields.RecordNumber;
                },
                CreationDateTime: function () {
                    return GetFormatedDateWithTime(formFields.CreationDateTime);
                },
                TransmissionDate: function () {
                    return GetFormatedDateWithTime(formFields.TransmissionDate);
                },
                User: function () {
                    return formFields.User;
                },
                value: function () {
                    return formFields.Value;
                },
                FieldName: function () {
                    return formFields.FieldName;
                },
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };
    const searchData = (formFields) => {
        var resultData = GetGridData(accessToken, formFields);
        setDataSource(resultData);
    };
    useEffect(() => {
        searchData(formFields);
    }, []);
    const deleteRecords = useCallback(() => {
        var deleteUrl = "rf/Message/DeleteMessageHeader";
        let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                setPanelOpen(false);
                dataGrid.current.instance().beginCustomLoading("Deleting");
                axios.post(
                    `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
                    selectedItemKeys,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                )
                    .then((res) => {
                        if (dataGrid.current && dataGrid.current.instance) {
                            dataGrid.current.instance().endCustomLoading();
                            dataGrid.current.instance().refresh();
                        }
                    })
                    .catch((err) => {
                        if (dataGrid.current && dataGrid.current.instance) {
                            dataGrid.current.instance().endCustomLoading();
                        }
                    });
            }
        });
    }, [selectedItemKeys]);
    const ReSubmitRFHeader = useCallback(() => {
        var reSubmitUrl = "rf/Message/ReSubmitRFHeader";
        let result = confirm("<i>Are you sure you want to resubmit the selected record?</i>", "Resubmit");
        result.then((dialogResult) => {
            if (dialogResult) {
                setPanelOpen(false);
                dataGrid.current.instance().beginCustomLoading("Resubmit");
                axios.post(
                    `${window._env_.REACT_APP_APIS}/${reSubmitUrl}`,
                    selectedItemKeys,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                )
                    .then((res) => {
                        notify(
                            {
                                message: "Record resubmitted successfully.",
                                width: 100,
                            },
                            'success',
                            3000,
                        );
                        if (dataGrid.current && dataGrid.current.instance) {
                            dataGrid.current.instance().endCustomLoading();
                            dataGrid.current.instance().refresh();
                        }
                    })
                    .catch((err) => {
                        if (dataGrid.current && dataGrid.current.instance) {
                            dataGrid.current.instance().endCustomLoading();
                        }
                    });
            }
        });
    }, [selectedItemKeys]);
    const handleReset = (e) => {
        setformFields(initialFormFields);
    };
    const [panelOpen, setPanelOpen] = useState(false);

    const handleRowClick = (e) => {
       // setSelectedItemKeys(e.data);
        setPanelOpen(true);
    };

    const closePanel = () => {
        setPanelOpen(false);
        // setTimeout(() => setSelectedItemKeys(null), 300);
    };
    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <Form pageTitle={pageTitle} setSearchPanelStatus={setSearchPanelStatus} handleReset={handleReset} formFields={formFields} setformFields={setformFields} ReSubmitRFHeader={ReSubmitRFHeader} deleteRecords={deleteRecords} searchData={searchData} selectedItemKeys={selectedItemKeys} />
                        <div className="message-list-page" style={{ display: 'flex', position: 'relative' }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                                    id="gridContainer"
                                    onContentReady={onContentReady}
                                    ref={dataGrid}
                                    dataSource={dataSource}
                                    selectedRowKeys={selectedItemKeys}
                                    showBorders={true}
                                    onRowClick={handleRowClick}
                                    rowAlternationEnabled={true}
                                    allowColumnReordering={true}
                                    allowColumnResizing={true}
                                    columnAutoWidth={true}
                                    onSelectionChanged={handleCellValueChanged}
                                    onRowInserting={onRowInserted}
                                    className={searchPanelStatus ? "TwoRowsGridHeight_AccordianOpen" : "GridHeight-AccordianClosed"}
                                >
                                    <ColumnChooser
                                        enabled={true}
                                        title="Choose Column"
                                        width={290}
                                        height={290}
                                        sortOrder="asc"
                                    >
                                        <ColumnChooserSearch
                                            enabled={true}
                                            editorOptions={{ placeholder: 'Search column' }} />
                                    </ColumnChooser>
                                    <StateStoring
                                        enabled={true}
                                        type="custom"
                                        customLoad={loadState}
                                        storageKey={gridKey}
                                        customSave={saveState}
                                    />
                                    <Scrolling mode="standard" />
                                    <Selection mode="single" />
                                    <Export enabled={true} allowExportSelectedData={true} />

                                    <Paging enabled={true} defaultPageSize={10} />
                                    <Pager
                                        visible={true}
                                        showPageSizeSelector={true}
                                        allowedPageSizes={allowedPageSizes}
                                        showNavigationButtons={true}
                                        showInfo={true}
                                    />
                                    <Editing
                                        mode="cell"
                                        refreshMode="repaint"
                                        allowUpdating={true}
                                        allowAdding={true}
                                    />
                                    <FilterRow visible={true} />
                                    <FilterPanel visible={true} />
                                    <Column dataField="RecordNumber" allowEditing={false} caption="Record#" />
                                    <Column dataField="Status" allowEditing={false} caption="Status" >
                                        <Lookup
                                            dataSource={statusOptions}
                                            displayExpr="Text"
                                            valueExpr="ID"
                                        />
                                    </Column>
                                    <Column dataField="StatusInfo" allowEditing={false} caption="Status Info" />
                                    <Column dataField="CreationDateTime" allowEditing={false} dataType="datetime" format="MM/dd/yyyy hh:mm aa" caption="Creation Auditable" />
                                    <Column dataField="TransmissionDate" allowEditing={false} dataType="date" format="MM/dd/yyyy" caption="Transmission Date" />
                                    <Column dataField="ProcessName" allowEditing={false} caption="Process Name" />
                                    <Column dataField="ProcessPage" allowEditing={false} caption="Process Page" />
                                    <Column dataField="User" allowEditing={false} caption="User" />
                                    <Column dataField="CommandOn" allowEditing={false} caption="RF Audit Command On" visible={false} />
                                    <Column dataField="AuditResult" allowEditing={false} caption="RF Audit Result" visible={false} />
                                    <Column dataField="LastUpdateDateTime" allowEditing={false} dataType="datetime" visible={false} format="MM/dd/yyyy hh:mm aa" caption="Update Auditable" />


                                    <Toolbar>
                                        <Item location="before">
                                            <Button className="accordianButton"  disabled={selectedItemKeys.length === 0}  onClick={ReSubmitRFHeader} text="Resubmit" type="default" />
                                        </Item>
                                        <Item location="before">
                                            <Button className="accordianButton"  disabled={selectedItemKeys.length === 0} onClick={deleteRecords} text="Delete" type="default" />
                                        </Item>
                                        <Item location="after">
                                            <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                        </Item>
                                        <Item name="exportButton" />
                                        <Item name="columnChooserButton" />
                                    </Toolbar>
                                </DataGrid>
                            </div>
                            {panelOpen && (
                                <div>
                                    <SidePanelGrid
                                        panelOpen={panelOpen}
                                        panelHeight={panelHeight}
                                        closePanel={closePanel}
                                    >
                                        <MessageDetailList
                                            headerId={headerId}
                                            panelHeight={panelContentHeight}
                                            searchPanelStatus={searchPanelStatus}
                                        />
                                    </SidePanelGrid>
                                </div>
                            )}
                        </div>
                        <div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(List);